
import ImageMeta from "@/mixins/imageMeta";

export default {
  name: "ImageTextSection",
  props: ['zone'],
  mixins: [ImageMeta],
  computed: {
    imageAttributes() {
      return this.getAttribute(this.zone, 'image.data.attributes');
    }
  },
}
